// Buffer TEE image digest — update whenever buffer-tee image is rebuilt.
// asia-south1-docker.pkg.dev/proj-tanuh-benchmark-ptfm/tanuh-buffer-tee/buffer-tee:flex-20260930
export const EXPECTED_IMAGE_DIGEST = "sha256:acd31e73a763a0ddd56ce9be89f8d2cb562fd6ebf96a2e75b3e604e5d7177ad0"
export const OIDC_AUDIENCE         = "ratls-browser"

// Refuse a Buffer TEE running the debug Confidential Space image (token
// dbgstat != "disabled-since-boot"). Keep false while the Buffer VM still boots
// confidential-space-debug; set true once it runs the production image.
export const REQUIRE_NON_DEBUG_TEE = false

// Benchmark leaderboard API; job results are read from here, not the Buffer TEE.
export const LEADERBOARD_API_BASE = "https://bodh.tanuh.ai/leaderboard"

export const OIDC_ISSUER           = "https://confidentialcomputing.googleapis.com"
export const OIDC_JWKS_URL         =
    "https://www.googleapis.com/service_accounts/v1/metadata/jwk/" +
    "signer@confidentialspace-sign.iam.gserviceaccount.com"
export const HPKE_INFO_PREFIX      = "ratls-cs-v1|"
export const WORKER_TIMEOUT_MS     = 30_000

// Link to the Buffer TEE source code — set once the repo is made public.
export const BUFFER_TEE_SOURCE_REPO_URL = ""
